export const dmsMenuDef = [



  {
    name: 'Document Cluster',
    resource: 'document_cluster',
    icon: 'fa fa-plus-square',
    url: 'document_cluster',
    auto_crud: true,
    breadcrumb: 'Document Cluster',
    showMenu: true
  }, {
    name: 'Document Constraints',
    resource: 'document_constraints',
    icon: 'fa fa-plus-square',
    url: 'document_constraints',
    auto_crud: true,
    breadcrumb: 'Document Constraints',
    showMenu: true
  },
  {
    name: 'Eula Document',
    resource: 'eula_document',
    icon: 'fa fa-plus-square',
    url: 'eula_document',
    auto_crud: true,
    breadcrumb: 'Eula Document',
    showMenu: true
  },
  {
    name: "Media Gallery",
    icon: "fa fa-building-o",
    resource: "media_gallery",
    url: "media_gallery",
    auto_crud: true,
    breadcrumb: "Gallery"
  },
  {
    "name": "DMS Permission Set",
    "icon": "fa fa-building-o",
    "resource": "dms_permission_set",
    "url": "dms_permission_set",
    "auto_crud": true,
    "breadcrumb": "DMS Permission Set"
  },
  {
    name: "Document RBAC",
    icon: "fa fa-building-o",
    resource: "document_rbac",
    url: "document_rbac",
    auto_crud: true,
    breadcrumb: "RBAC"
  },
  {
    name: "Dicom Order",
    icon: "fa fa-building-o",
    resource: "dicom_orders",
    url: "dicom_orders",
    auto_crud: true,
    breadcrumb: "Dicom Order"
  },
  {
    name: "Dicom Metadata Tab",
    icon: "fa fa-building-o",
    resource: "dicom_metadata_tab",
    url: "dicom_metadata_tab",
    auto_crud: true,
    breadcrumb: "Dicom Metadata Tab"
  },
  {
    name: "Dicom Metadata",
    icon: "fa fa-building-o",
    resource: "sss_metadata",
    url: "sss_metadata",
    auto_crud: true,
    breadcrumb: "Dicom Metadata"
  },
  {
    name: 'Account Document Cluster',
    resource: 'account_document_cluster',
    icon: 'fa fa-plus-square',
    url: 'account_document_cluster',
    auto_crud: true,
    breadcrumb: 'Account Document Cluster',
    showMenu: true
  }
]